"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class MarketingPreference {
}
exports.default = MarketingPreference;
//# sourceMappingURL=MarketingPreference.js.map